<!--
  HeaderFocusService/BpSdkQuestionSetNextButtonComponent will automatically
  focus the header when the question set changes as it has
  the autofocusId and tabindex is "-1"
-->
<h2 class="emperor-ui-question-set-header" [id]="autofocusId" tabindex="-1">
  {{ name }}
</h2>
